import { GridApiCommunity } from "@mui/x-data-grid/internals"
import { GridColDef } from "@mui/x-data-grid"
import { DownLoadHeader, DownLoadRecord } from "components/download/csv/types"
import { GridColumnDefMap } from "./types"

export const makeDownloadData = <T>(
	api: GridApiCommunity,
	columns: GridColDef[],
	columnsDef: GridColumnDefMap<T>
) => {
	const body: DownLoadRecord[] = []
	const rowCount = api.getRowsCount()
	if (rowCount === 0) return null

	for(let i = 0; i < rowCount; i++) {
		const rowId = api.getRowIdFromRowIndex(i)
		const rowData = api.getRow(rowId)
		const row: DownLoadRecord = {}
		for(const col of columns) {
			const { downloadable, subField, hasKana, split, limitRow } = columnsDef[col.field]
			if (downloadable === false) continue
			
			if (subField && columns.some(c => c.field === subField) === false) {
				row[subField] = rowData[subField]
			}
			const value = rowData[col.field]
			if (typeof value === 'string') {
				const str = value.replace(/\t/g, ' ')
				if (split) {
					str.split('\n').forEach((v, j) => {
						if (v === '') return
						row[`${col.field}_${j + 1}`] = v
					})
				} else if (hasKana) {
					const at = str.indexOf('\n')
					if (at < 0) {
						row[col.field] = str
					}
					row[`${col.field}_kana`] = str.substring(0, at)
					row[col.field] = str.substring(at + 1)
				} else {
					const rows = str.split('\n').map(row => row.replaceAll("\t", " "))
					if (!limitRow || rows.length <= limitRow) {
						row[col.field] = rows.join('\n')
					} else {
						row[col.field] = rows.slice(0, limitRow).join('\n') + `\n(他 ${rows.length - limitRow} 件)`
					}
				}
			} else {
				row[col.field] = value
			}
		}
		body.push(row)
	}
	const header: DownLoadHeader[] = columns.flatMap(col => {
		const column = columnsDef[col.field]
		if (column.downloadable === false) return []
		
		if (column.split) {
			return Array.from({ length: column.split }).map((_, i) => ({
				title: `${column.headerName ?? col.field}_${i + 1}`,
				key: `${col.field}_${i + 1}`,
				unit: column.suffix
			}))
		} else {
			const header = [{
				title: column.headerName ?? col.field,
				key: col.field,
				unit: column.suffix
			}]
			if (column.hasKana) {
				header.push({
					title: `${column.headerName ?? col.field}(カナ)`,
					key: `${col.field}_kana`,
					unit: column.suffix
				})
			}
			if (column.subField && columns.some(c => c.field === column.subField) === false) {
				const subField = columnsDef[column.subField]
				if (subField) {
					header.push({
						title: subField.headerName ?? column.subField,
						key: column.subField,
						unit: subField.suffix
					})
				}
			}
			return header
		}
	})
	return { header, body }
}
